jQuery( document ).ready( function ($) {
    "use strict";

    $( window ).scroll( function() {

        var scroll = $( window ).scrollTop();

        if ( scroll > 0 ) {
            $( '.header' ).addClass( 'header--scrolled' );
        } else {
            $( '.header' ).removeClass( 'header--scrolled' );
        }

    });

    $( '.mobile-menu__item.menu-item-has-children' ).on( 'click', function (e) {
        $( this ).toggleClass( 'mobile-menu__item--active' );
        $( this ).siblings().removeClass( 'mobile-menu__item--active' );
    });

    function adjustMobileNav() {

        if ( $( '.mobile-menu' ).length && $( '.discount-001--header' ).length ) {
            $( '.mobile-menu' ).css( 'marginTop', $( '.discount-001--header' ).outerHeight() );
        }

        if ( $( '.main-content > div:first-child' ).length && $( '.discount-001--header' ).length )  {
            $( '.main-content > div:first-child' ).css( 'marginTop', $( '.discount-001--header' ).outerHeight() );
        }
    }

    function positionCart() {

        if ( $( '.mini-cart' ).length ) {
            $( '.mini-cart' ).css( 'marginTop', $( '.header' ).outerHeight() );
        }

    }

    adjustMobileNav();
    positionCart();

    $( window ).on( 'resize', function() {
        adjustMobileNav();
        positionCart();
    });

});
